//
import axios from 'axios'

/**
 * 
 */
const update = async ( id, data ) => {

    //
    try {
        
        //
        const response = await axios.put( process.env.VUE_APP_API_ROUTE + '/wh_promo/' + id, data )

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default update
